import {
  Box,
  IconButton,
  TextField,
  FormControl,
  Typography,
  useTheme,
  InputAdornment,
  Button,
} from "@mui/material";
import { Flex } from "~/components/Flex";
import { Command } from "~/components/guides/components/command";
import { Controller, UseFormReturn } from "react-hook-form";
import { copyToClipboard } from "~/lib/clipboard";
import { FileCopy } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { GithubIcon } from "~/icons";
import { GithubSecurityPipelineFormInput } from "~/pages/integrations/security-pipeline/security-pipeline-github/types";

export interface SecurityPipelineGithubSetupStepOneProps {
  formMethods: UseFormReturn<GithubSecurityPipelineFormInput>;
  watchRepoName: string;
}

export const SecurityPipelineGithubSetupStepOne = ({
  formMethods,
  watchRepoName,
}: SecurityPipelineGithubSetupStepOneProps) => {
  const theme = useTheme();

  return (
    <Box pb={4}>
      <Command
        number={1}
        options={{
          fontSize: { xs: 16 },
          dotColor: theme.palette.background.lightest,
        }}
      >
        Create an empty repo to get started
      </Command>

      <Box sx={{ mt: 2, pl: 6 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2, mt: 2 }}
        >
          Security pipeline uses an empty repo to manage your security patches.
          Create an empty repo per space you wish to run auto fixing on.
        </Typography>
        <Flex gap={1}>
          <Controller
            control={formMethods.control}
            name="repoName"
            render={({ field }) => (
              <FormControl>
                <TextField
                  size="small"
                  autoComplete="off"
                  sx={{ minWidth: "250px" }}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              copyToClipboard(watchRepoName || "");
                            }}
                            aria-label="copy repository name"
                            edge="end"
                          >
                            <FileCopy />
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                  {...field}
                />
              </FormControl>
            )}
          />
          <Button
            component={RouterLink}
            to={`https://github.com/new?name=${watchRepoName || ""}&visibility=private`}
            target="_blank"
            rel="noopener"
            variant="contained"
            color="primary"
            endIcon={<GithubIcon />}
          >
            Open GitHub
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};
